/* tslint:disable */
/* eslint-disable */
/* @relayHash 1367f9bc50deb11cd360031b83da5c8a */

import { ConcreteRequest } from "relay-runtime";
export type pdpSharedNotificationPdpSourcingModalConfigQueryVariables = {
    itemIds: Array<string | null>;
    userId?: string | null;
};
export type pdpSharedNotificationPdpSourcingModalConfigQueryResponse = {
    readonly viewer: {
        readonly soldHoldPdpSourcingModal: boolean | null;
        readonly item: ReadonlyArray<{
            readonly displayInfo?: {
                readonly ctas: {
                    readonly showRequestSourcing: boolean | null;
                } | null;
            } | null;
        } | null> | null;
    };
};
export type pdpSharedNotificationPdpSourcingModalConfigQuery = {
    readonly response: pdpSharedNotificationPdpSourcingModalConfigQueryResponse;
    readonly variables: pdpSharedNotificationPdpSourcingModalConfigQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "itemIds",
    "type": "[String]!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String",
    "defaultValue": ""
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": "soldHoldPdpSourcingModal",
  "name": "featureFlag",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "soldHoldPdpSourcingModal"
    }
  ],
  "storageKey": "featureFlag(feature:\"soldHoldPdpSourcingModal\")"
},
v2 = [
  {
    "kind": "Variable",
    "name": "itemIds",
    "variableName": "itemIds"
  }
],
v3 = {
  "kind": "InlineFragment",
  "type": "Item",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "displayInfo",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Literal",
          "name": "page",
          "value": "pdp"
        }
      ],
      "concreteType": "ItemDisplayInfo",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "ctas",
          "storageKey": null,
          "args": null,
          "concreteType": "CTADisplay",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "showRequestSourcing",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "pdpSharedNotificationPdpSourcingModalConfigQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": "item",
            "name": "itemRead",
            "storageKey": null,
            "args": (v2/*: any*/),
            "concreteType": null,
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "pdpSharedNotificationPdpSourcingModalConfigQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": "item",
            "name": "itemRead",
            "storageKey": null,
            "args": (v2/*: any*/),
            "concreteType": null,
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              },
              (v4/*: any*/),
              (v3/*: any*/)
            ]
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "pdpSharedNotificationPdpSourcingModalConfigQuery",
    "id": "app-buyer-finding/292.0.0-2020-11-20T23:59:39.967Z/pdpSharedNotificationPdpSourcingModalConfigQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'b96615f3483daa3ad2b89ebbb2ced030';
export default node;
